import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';
import { TextArea, TextAreaProps } from 'shared/ui/controls/text-area';

export interface TextareaFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<FieldWrapperProps, 'children'>,
    Omit<TextAreaProps, 'defaultValue' | 'name' | 'className'> {
  rows?: number;
  isSmallSize?: boolean;
}

export const TextareaField = <T extends FieldValues>({
  label,
  required,
  rows = 3,
  isSmallSize,
  ...props
}: TextareaFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController(props);

  const { value, ...rest } = field;

  return (
    <FieldWrapper label={label} error={error} required={required}>
      <TextArea rows={rows} error={error} value={value ?? ''} {...rest} {...props} isSmallSize={isSmallSize} />
    </FieldWrapper>
  );
};
